import useMessage from '@/natives/libs/hooks/useMessage';
import i18n from '@/natives/libs/i18n';
import getErrorTip from '@/natives/libs/request/getErrorTip';
function checkAzureArCode() {
  if (sessionStorage.getItem('azureArCode')) {
    let errcode = sessionStorage.getItem('azureArCode');
    sessionStorage.removeItem('azureArCode');
    let title = i18n.t('error');
    let type = 'error';
    return useMessage({
      title,
      type,
      message: getErrorTip(i18n)(errcode)
    });
  }
}
checkAzureArCode();